export default __webpack_public_path__ + "static/media/Henwee-Horse.48a0d547.png";